// Categories for styling services
// Categories - matches stylist specialties
  export const categories = [
    { id: 'all', label: 'All' },
    { id: 'hair', label: 'Hair' },
    { id: 'barber', label: 'Barber' },
    { id: 'braiding', label: 'Braiding' },
    { id: 'makeup', label: 'Makeup' },
    { id: 'nails', label: 'Nails' },
    { id: 'skincare', label: 'Skincare' },
    { id: 'massage', label: 'Massage' },
    { id: 'lashes', label: 'Lashes' },
    { id: 'brows', label: 'Brows' },
    { id: 'waxing', label: 'Waxing' },
    { id: 'extensions', label: 'Extensions' },
    { id: 'wellness', label: 'Wellness' },
    { id: 'fitness', label: 'Fitness' },
    { id: 'therapy', label: 'Therapy' },
  ];
  
  // Distance filter options
  export const distanceOptions = [
    { id: 'any', label: 'Any Distance' },
    { id: '5', label: 'Within 5 miles' },
    { id: '10', label: 'Within 10 miles' },
    { id: '25', label: 'Within 25 miles' },
    { id: '50', label: 'Within 50 miles' },
  ];
  
  // Sort options for stylist listings
  export const sortOptions = [
    { id: 'recommended', label: 'Recommended' },
    { id: 'rating', label: 'Top Rated' },
    { id: 'distance', label: 'Nearest' },
    { id: 'price_low', label: 'Price (Low to High)' },
    { id: 'price_high', label: 'Price (High to Low)' },
  ];
  
  // Rating filter options
  export const ratingOptions = [
    { value: 5, label: '5 stars' },
    { value: 4, label: '4+ stars' },
    { value: 3, label: '3+ stars' },
    { value: 2, label: '2+ stars' },
    { value: 1, label: '1+ stars' },
  ];
  
  // Price range options
  export const priceRangeMax = 500; // Maximum price for filters
  export const priceRangeMin = 0; // Minimum price for filters
  
  // Default filters
  export const defaultFilters = {
    specialties: [],
    maxDistance: 50,
    minRating: 0,
    priceRange: [0, 500],
    availability: '',
    sortBy: 'recommended',
    showOnlyNearby: false
  };